module.exports = __webpack_public_path__ + "static/media/movementArrowRight.47b6c7ec.svg";